import { LoadableAfterPaint } from '@confluence/loadable';

export const ProfilePictureMacroHandler = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ProfilePictureMacro" */ '../src/profile-picture/ProfilePictureMacroRenderer.tsx'
			)
		).ProfilePictureMacroRenderer,
});
